import { NewsType } from '../../../services/newsService/newsService.interface'

export enum NewsLinkLabels {
    POLICE = 'PoliceNewsLink',
    RSS = 'RssNewsLink',
}

export enum NewsPropertyKeys {
    PAGE_SIZE = 'meinestadt/resultlist#pageSize',
    REVERSE_ORDER = 'meinestadt/newstabs#switchOrder',
}

export enum NewsTrackingIds {
    CLICK_NEWS_POLICE = 'ed0000208',
    CLICK_NEWS_RSS = 'ed0000224',
}

export enum NewsTrackingText {
    POLICE = 'meldung',
    RSS = 'RSS_Feed_Meldung',
}

export interface NewsOptions {
    police?: string
    rss?: string
}

export interface ViewNewsItem {
    key: string
    caption: string
    headline: string
    linkText: string
    type?: NewsType
    link: NewsLink | null
    text: string
    id: number
    provider: string
    position?: number
}

export interface NewsLink {
    url: string
    target: string
    rel: string
}
